import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";

export const Route = createFileRoute("/unsubscribe")({
  head: () => ({
    meta: [
      { title: "Cancelar suscripción | Mine Class" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: UnsubscribePage,
});

type State = "loading" | "valid" | "already" | "invalid" | "done" | "error";

function UnsubscribePage() {
  const [state, setState] = useState<State>("loading");
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    const t = new URL(window.location.href).searchParams.get("token");
    setToken(t);
    if (!t) { setState("invalid"); return; }
    fetch(`/email/unsubscribe?token=${encodeURIComponent(t)}`)
      .then((r) => r.json().then((j) => ({ ok: r.ok, j })))
      .then(({ ok, j }) => {
        if (!ok) setState("invalid");
        else if (j.reason === "already_unsubscribed") setState("already");
        else if (j.valid) setState("valid");
        else setState("invalid");
      })
      .catch(() => setState("error"));
  }, []);

  async function confirm() {
    if (!token) return;
    const r = await fetch("/email/unsubscribe", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    });
    const j = await r.json();
    if (r.ok && j.success) setState("done");
    else if (j.reason === "already_unsubscribed") setState("already");
    else setState("error");
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-[var(--color-surface-container-low)]">
      <div className="bg-white border border-[var(--color-outline-variant)] p-8 max-w-md w-full text-center space-y-4">
        <h1 className="text-xl font-bold">Cancelar suscripción</h1>
        {state === "loading" && <p className="text-sm">Validando enlace…</p>}
        {state === "invalid" && <p className="text-sm">El enlace es inválido o expiró.</p>}
        {state === "error" && <p className="text-sm">Ocurrió un error. Intenta nuevamente más tarde.</p>}
        {state === "already" && <p className="text-sm">Este correo ya está dado de baja.</p>}
        {state === "valid" && (
          <>
            <p className="text-sm">¿Confirmas que deseas dejar de recibir correos de Mine Class?</p>
            <button onClick={confirm}
              className="px-4 py-2 bg-[var(--color-brand-coral)] text-white text-sm font-bold uppercase tracking-wider">
              Confirmar baja
            </button>
          </>
        )}
        {state === "done" && <p className="text-sm">Listo. No recibirás más correos.</p>}
      </div>
    </div>
  );
}
